import React from "react";
import {Link, useLocation} from "react-router-dom";
import {useAuth} from "../contexts/AuthContext";
import "../App.css";

const Navigation: React.FC = () => {
  const {user, logout, sessionTimeRemaining} = useAuth();
  const location = useLocation();

  // Format session time remaining
  const formatTimeRemaining = (ms: number | null): string => {
    if (!ms || ms <= 0) return "Expired";
    const hours = Math.floor(ms / (60 * 60 * 1000));
    const minutes = Math.floor((ms % (60 * 60 * 1000)) / (60 * 1000));
    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    }
    return `${minutes}m`;
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <header className="app-header">
      <div className="header-top">
        <div className="header-brand">
          <h1 className="header-title">ChatGPT Compliance Export Portal</h1>
          <p className="header-subtitle">Enterprise User Content Migration Tool</p>
        </div>
        <div className="header-user">
          <div className="user-info">
            <span className="user-label">Signed in as:</span>
            <span className="user-email-nav">{user?.email}</span>
            {sessionTimeRemaining !== null && (
              <span className="session-time" style={{
                fontSize: "0.7rem",
                opacity: 0.8,
                marginTop: "0.25rem"
              }}>
                Session: {formatTimeRemaining(sessionTimeRemaining)}
              </span>
            )}
          </div>
          <button className="btn btn-secondary" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
      <nav className="nav">
        <div className="nav-content">
          <div className="nav-links">
            <Link
              to="/dashboard"
              className={`nav-link ${
                location.pathname === "/dashboard" ? "active" : ""
              }`}
            >
              Dashboard
            </Link>
            <Link
              to="/jobs"
              className={`nav-link ${
                location.pathname === "/jobs" ? "active" : ""
              }`}
            >
              Export Jobs
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navigation;

